import { render, staticRenderFns } from "./AppBarChart.vue?vue&type=template&id=3ecabc58&"
import script from "./AppBarChart.vue?vue&type=script&lang=js&"
export * from "./AppBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports